<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Lead Lovers</h3>
      </div>
      <div class="box-content">
        <p>
          Para começar a útilizar precisamos que você informe o Token Api da sua conta na leadlovers.
        </p>
        <p class="margin-top-s">
          Acesse: <a href="https://leadlovers.com.br" target="_blank">https://leadlovers.com.br</a>
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Token Api</label>
              <input class="input" type="text" v-model="token" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveLeadLovers()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";


export default {
  name: "lead-lovers",
  components: {},
  data() {
    return {
      token: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveLeadLovers() {
      let data = {
        token: this.token,
      };

      if (!data.token) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        leadlovers: {
          token: this.token,
        },
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.token = result.leadlovers.token;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
